var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 22,
    height: 20,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 10C24 10.5523 23.5523 11 23 11H3C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H23C23.5523 9 24 9.44772 24 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9C13.5523 9 14 9.44771 14 10L14 23C14 23.5523 13.5523 24 13 24C12.4477 24 12 23.5523 12 23L12 10C12 9.44772 12.4477 9 13 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOverview);
export default __webpack_public_path__ + "static/media/menu-overview.ee59c2b41eafb65b0002dcd9f7449a3f.svg";
export { ForwardRef as ReactComponent };